module.exports = __webpack_public_path__ + "fontawesome-webfont.674f50d287a8c48dc19b.eot";


//////////////////
// WEBPACK FOOTER
// /app/~/font-awesome/fonts/fontawesome-webfont.eot?v=4.7.0
// module id = ../../../../font-awesome/fonts/fontawesome-webfont.eot?v=4.7.0
// module chunks = 13